import { render, staticRenderFns } from "./MarketingIndex.vue?vue&type=template&id=62e22fba&scoped=true&"
import script from "./MarketingIndex.vue?vue&type=script&lang=js&"
export * from "./MarketingIndex.vue?vue&type=script&lang=js&"
import style0 from "./MarketingIndex.vue?vue&type=style&index=0&id=62e22fba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e22fba",
  null
  
)

export default component.exports